import React from 'react';

/**
 * Answering status icon component
 * Displays simple circle to indicate answering/speaking state
 */
const AnsweringIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="12" 
    height="12" 
    viewBox="0 0 12 12" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export default AnsweringIcon;
